import { render, staticRenderFns } from "./EquipmentListCard.vue?vue&type=template&id=54961f2b&scoped=true&"
import script from "./EquipmentListCard.vue?vue&type=script&lang=ts&"
export * from "./EquipmentListCard.vue?vue&type=script&lang=ts&"
import style0 from "./EquipmentListCard.vue?vue&type=style&index=0&id=54961f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54961f2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
